// Auto-generated from ateco-codes-it.json — do not edit manually
// To regenerate: node scripts/generate-valid-ateco-codes.mjs

const validAtecoCodesSet = new Set<string>([
  '01',
  '02',
  '03',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '011',
  '012',
  '13',
  '14',
  '014',
  '15',
  '16',
  '016',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '031',
  '32',
  '032',
  '33',
  '35',
  '38',
  '42',
  '43',
  '46',
  '47',
  '49',
  '50',
  '51',
  '52',
  '53',
  '55',
  '56',
  '58',
  '59',
  '60',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '68',
  '69',
  '70',
  '71',
  '72',
  '072',
  '73',
  '74',
  '77',
  '78',
  '79',
  '81',
  '081',
  '82',
  '84',
  '85',
  '86',
  '87',
  '88',
  '089',
  '90',
  '91',
  '93',
  '94',
  '95',
  '96',
  '98',
  '101',
  '103',
  '104',
  '105',
  '106',
  '107',
  '108',
  '109',
  '110',
  '0113',
  '0119',
  '139',
  '142',
  '0148',
  '151',
  '0161',
  '161',
  '162',
  '0163',
  '171',
  '172',
  '181',
  '201',
  '204',
  '205',
  '221',
  '222',
  '231',
  '233',
  '234',
  '235',
  '236',
  '239',
  '243',
  '244',
  '245',
  '251',
  '252',
  '255',
  '256',
  '259',
  '261',
  '265',
  '271',
  '273',
  '275',
  '281',
  '282',
  '284',
  '289',
  '293',
  '301',
  '303',
  '309',
  '321',
  '329',
  '331',
  '351',
  '352',
  '381',
  '382',
  '383',
  '421',
  '422',
  '429',
  '431',
  '432',
  '433',
  '434',
  '439',
  '461',
  '462',
  '463',
  '464',
  '466',
  '467',
  '468',
  '471',
  '472',
  '475',
  '476',
  '477',
  '478',
  '479',
  '491',
  '493',
  '494',
  '512',
  '522',
  '523',
  '561',
  '562',
  '581',
  '582',
  '591',
  '603',
  '639',
  '641',
  '642',
  '643',
  '649',
  '651',
  '661',
  '662',
  '681',
  '683',
  '711',
  '731',
  '741',
  '749',
  '771',
  '772',
  '773',
  '775',
  '791',
  '800',
  '812',
  '829',
  '841',
  '842',
  '853',
  '855',
  '856',
  '862',
  '869',
  '879',
  '889',
  '901',
  '903',
  '911',
  '912',
  '914',
  '931',
  '932',
  '941',
  '949',
  '952',
  '953',
  '962',
  '969',
  '1041',
  '1051',
  '1061',
  '1071',
  '1102',
  '01131',
  '01191',
  '1392',
  '1399',
  '1410',
  '1421',
  '01489',
  '1520',
  '01619',
  '01620',
  '1628',
  '1920',
  '2041',
  '2059',
  '2211',
  '2226',
  '2315',
  '2352',
  '2370',
  '2420',
  '2512',
  '2521',
  '2530',
  '2563',
  '2593',
  '2599',
  '2651',
  '2670',
  '2811',
  '2821',
  '2829',
  '2830',
  '2894',
  '2899',
  '3091',
  '3092',
  '3100',
  '03210',
  '3212',
  '03220',
  '3240',
  '3250',
  '3299',
  '3312',
  '3318',
  '3821',
  '4618',
  '4621',
  '4631',
  '4632',
  '4633',
  '4634',
  '4641',
  '4642',
  '4643',
  '4644',
  '4646',
  '4647',
  '4649',
  '4650',
  '4664',
  '4671',
  '4673',
  '4682',
  '4683',
  '4684',
  '4686',
  '4687',
  '4712',
  '4724',
  '4727',
  '4740',
  '4751',
  '4752',
  '4753',
  '4755',
  '4762',
  '4763',
  '4769',
  '4771',
  '4772',
  '4773',
  '4776',
  '4778',
  '4779',
  '4781',
  '4783',
  '4791',
  '4792',
  '4933',
  '4950',
  '5110',
  '5210',
  '5221',
  '5224',
  '5520',
  '5611',
  '5920',
  '6190',
  '6220',
  '6310',
  '6419',
  '6492',
  '6619',
  '6910',
  '7112',
  '7120',
  '7210',
  '7411',
  '7420',
  '7499',
  '7722',
  '7739',
  '8001',
  '8123',
  '8291',
  '8292',
  '8299',
  '8411',
  '8412',
  '8413',
  '8424',
  '8531',
  '8540',
  '8559',
  '08930',
  '08990',
  '9311',
  '9319',
  '9329',
  '9412',
  '9499',
  '9510',
  '9529',
  '9531',
  '9610',
  '9623',
  '9699',
  '9700',
  '10200',
  '10611',
  '10730',
  '10830',
  '10850',
  '10890',
  '11070',
  '011100',
  '011200',
  '011311',
  '011312',
  '011313',
  '011320',
  '011330',
  '011400',
  '011500',
  '011600',
  '011911',
  '011912',
  '011913',
  '011990',
  '012100',
  '012200',
  '012300',
  '012400',
  '012500',
  '012600',
  '012700',
  '012800',
  '012900',
  '013000',
  '014100',
  '014200',
  '014300',
  '014400',
  '014500',
  '014600',
  '014700',
  '014810',
  '014820',
  '014830',
  '014840',
  '014891',
  '014899',
  '015000',
  '016110',
  '016191',
  '016199',
  '016201',
  '016209',
  '16230',
  '16281',
  '016310',
  '016320',
  '017000',
  '17230',
  '20591',
  '20599',
  '021000',
  '21200',
  '022000',
  '22240',
  '22261',
  '22269',
  '023000',
  '23610',
  '23650',
  '23660',
  '024000',
  '24330',
  '24510',
  '24530',
  '24540',
  '25631',
  '26300',
  '26400',
  '26512',
  '26600',
  '26701',
  '27400',
  '27900',
  '28220',
  '28294',
  '28299',
  '28309',
  '28970',
  '28999',
  '30911',
  '31001',
  '31003',
  '031100',
  '031200',
  '032101',
  '032109',
  '032201',
  '032209',
  '32300',
  '32505',
  '32999',
  '033000',
  '33110',
  '33125',
  '33129',
  '33130',
  '33200',
  '38211',
  '39000',
  '43120',
  '43210',
  '43220',
  '43240',
  '43310',
  '43320',
  '43340',
  '43990',
  '46110',
  '46120',
  '46130',
  '46140',
  '46150',
  '46160',
  '46170',
  '46181',
  '46182',
  '46183',
  '46184',
  '46189',
  '46212',
  '46240',
  '46321',
  '46323',
  '46350',
  '46370',
  '46463',
  '46492',
  '46494',
  '46499',
  '46641',
  '46645',
  '46649',
  '46822',
  '46832',
  '46850',
  '47110',
  '47210',
  '47260',
  '47523',
  '47531',
  '47632',
  '47691',
  '47699',
  '47721',
  '47740',
  '47782',
  '47789',
  '47793',
  '47922',
  '47923',
  '49310',
  '49320',
  '051000',
  '052000',
  '52220',
  '52250',
  '52260',
  '55203',
  '55204',
  '55205',
  '55300',
  '56111',
  '56112',
  '56119',
  '56120',
  '56210',
  '56220',
  '56300',
  '061000',
  '61100',
  '062000',
  '62900',
  '63102',
  '64929',
  '66192',
  '66290',
  '66300',
  '68200',
  '68320',
  '69200',
  '70200',
  '071000',
  '71110',
  '71201',
  '71202',
  '072100',
  '72102',
  '72200',
  '072900',
  '73110',
  '73300',
  '74120',
  '74140',
  '74201',
  '74991',
  '74992',
  '74993',
  '74994',
  '74999',
  '77210',
  '77399',
  '79900',
  '80011',
  '80012',
  '081100',
  '081200',
  '81220',
  '81239',
  '82300',
  '82400',
  '82991',
  '82999',
  '85320',
  '85510',
  '85520',
  '85599',
  '85690',
  '86220',
  '86910',
  '86940',
  '86960',
  '86990',
  '88990',
  '089100',
  '089200',
  '089301',
  '089302',
  '089303',
  '089901',
  '089909',
  '90110',
  '90200',
  '90390',
  '091000',
  '91300',
  '92000',
  '93130',
  '93199',
  '93299',
  '95102',
  '95220',
  '95240',
  '95292',
  '95299',
  '95319',
  '96101',
  '96102',
  '96220',
  '96239',
  '96300',
  '96991',
  '96999',
  '099000',
  '101100',
  '101200',
  '101300',
  '102001',
  '102009',
  '103100',
  '103200',
  '103900',
  '104110',
  '104120',
  '104130',
  '104200',
  '105110',
  '105120',
  '105200',
  '106111',
  '106119',
  '106120',
  '106190',
  '106200',
  '107110',
  '107120',
  '107200',
  '107301',
  '107302',
  '108100',
  '108200',
  '108301',
  '108302',
  '108400',
  '108501',
  '108502',
  '108503',
  '108504',
  '108505',
  '108509',
  '108600',
  '108901',
  '108909',
  '109100',
  '109200',
  '110100',
  '110210',
  '110220',
  '110300',
  '110400',
  '110500',
  '110600',
  '110701',
  '110702',
  '120000',
  '131000',
  '132000',
  '133000',
  '139100',
  '139210',
  '139220',
  '139300',
  '139400',
  '139500',
  '139600',
  '139910',
  '139990',
  '141010',
  '141020',
  '142110',
  '142120',
  '142200',
  '142300',
  '142400',
  '142900',
  '151100',
  '151200',
  '152010',
  '152020',
  '161100',
  '161200',
  '162100',
  '162200',
  '162301',
  '162309',
  '162400',
  '162500',
  '162600',
  '162700',
  '162811',
  '162819',
  '162820',
  '162830',
  '171100',
  '171200',
  '172100',
  '172200',
  '172301',
  '172309',
  '172400',
  '172500',
  '181100',
  '181200',
  '181300',
  '181400',
  '182000',
  '191000',
  '192010',
  '192020',
  '192030',
  '192040',
  '192090',
  '201100',
  '201200',
  '201300',
  '201400',
  '201500',
  '201600',
  '201700',
  '202000',
  '203000',
  '204110',
  '204120',
  '204200',
  '205100',
  '205911',
  '205912',
  '205920',
  '205930',
  '205991',
  '205999',
  '206000',
  '211000',
  '212001',
  '212009',
  '221110',
  '221120',
  '221200',
  '222100',
  '222200',
  '222300',
  '222401',
  '222409',
  '222500',
  '222611',
  '222612',
  '222691',
  '222699',
  '231100',
  '231200',
  '231300',
  '231400',
  '231510',
  '231590',
  '232000',
  '233100',
  '233200',
  '234100',
  '234200',
  '234300',
  '234400',
  '234500',
  '235100',
  '235210',
  '235220',
  '236101',
  '236102',
  '236103',
  '236104',
  '236109',
  '236200',
  '236300',
  '236400',
  '236501',
  '236502',
  '236601',
  '236609',
  '237010',
  '237020',
  '237030',
  '239100',
  '239900',
  '241000',
  '242010',
  '242020',
  '243100',
  '243200',
  '243301',
  '243302',
  '243303',
  '243400',
  '244100',
  '244200',
  '244300',
  '244400',
  '244500',
  '244600',
  '245101',
  '245102',
  '245109',
  '245200',
  '245301',
  '245302',
  '245303',
  '245309',
  '245401',
  '245402',
  '245403',
  '245409',
  '251100',
  '251210',
  '251220',
  '252110',
  '252120',
  '252200',
  '253010',
  '253020',
  '254000',
  '255100',
  '255200',
  '255300',
  '256100',
  '256200',
  '256311',
  '256312',
  '256320',
  '259100',
  '259200',
  '259310',
  '259320',
  '259330',
  '259400',
  '259910',
  '259920',
  '259990',
  '261100',
  '261200',
  '262000',
  '263001',
  '263009',
  '264001',
  '264009',
  '265110',
  '265121',
  '265129',
  '265200',
  '266001',
  '266002',
  '267011',
  '267012',
  '267020',
  '267030',
  '271100',
  '271200',
  '272000',
  '273100',
  '273200',
  '273300',
  '274001',
  '274002',
  '274009',
  '275100',
  '275200',
  '279001',
  '279002',
  '279003',
  '279004',
  '279009',
  '281110',
  '281120',
  '281200',
  '281300',
  '281400',
  '281500',
  '282110',
  '282120',
  '282201',
  '282209',
  '282300',
  '282400',
  '282500',
  '282910',
  '282920',
  '282930',
  '282941',
  '282949',
  '282991',
  '282992',
  '282999',
  '283010',
  '283091',
  '283099',
  '284100',
  '284200',
  '289100',
  '289200',
  '289300',
  '289410',
  '289420',
  '289430',
  '289500',
  '289600',
  '289701',
  '289702',
  '289709',
  '289910',
  '289920',
  '289991',
  '289992',
  '289993',
  '289999',
  '291000',
  '292000',
  '293100',
  '293200',
  '301100',
  '301200',
  '301300',
  '302000',
  '303100',
  '303200',
  '304000',
  '309111',
  '309112',
  '309120',
  '309210',
  '309220',
  '309230',
  '309240',
  '309900',
  '310011',
  '310012',
  '310013',
  '310014',
  '310015',
  '310020',
  '310031',
  '310032',
  '310033',
  '310034',
  '310035',
  '310036',
  '310037',
  '310039',
  '321100',
  '321210',
  '321220',
  '321300',
  '322000',
  '323001',
  '323009',
  '324010',
  '324020',
  '325010',
  '325020',
  '325030',
  '325040',
  '325051',
  '325052',
  '325053',
  '329100',
  '329910',
  '329920',
  '329930',
  '329940',
  '329991',
  '329999',
  '331101',
  '331102',
  '331103',
  '331104',
  '331105',
  '331106',
  '331109',
  '331210',
  '331220',
  '331230',
  '331240',
  '331251',
  '331252',
  '331253',
  '331254',
  '331259',
  '331260',
  '331270',
  '331291',
  '331292',
  '331299',
  '331301',
  '331302',
  '331309',
  '331400',
  '331500',
  '331600',
  '331700',
  '331810',
  '331820',
  '331830',
  '331900',
  '332001',
  '332002',
  '332003',
  '332004',
  '332005',
  '332006',
  '332007',
  '332009',
  '351100',
  '351200',
  '351300',
  '351400',
  '351500',
  '351600',
  '352100',
  '352200',
  '352300',
  '352400',
  '353000',
  '354000',
  '360000',
  '370000',
  '381100',
  '381200',
  '382111',
  '382112',
  '382120',
  '382130',
  '382140',
  '382200',
  '382300',
  '383100',
  '383200',
  '383300',
  '390001',
  '390009',
  '410000',
  '421100',
  '421200',
  '421300',
  '422100',
  '422200',
  '429100',
  '429900',
  '431100',
  '431201',
  '431209',
  '431300',
  '432101',
  '432102',
  '432103',
  '432104',
  '432105',
  '432201',
  '432202',
  '432203',
  '432204',
  '432205',
  '432206',
  '432207',
  '432300',
  '432401',
  '432402',
  '432409',
  '433101',
  '433102',
  '433201',
  '433202',
  '433300',
  '433401',
  '433402',
  '433500',
  '434100',
  '434200',
  '435000',
  '436000',
  '439100',
  '439901',
  '439902',
  '439909',
  '461101',
  '461102',
  '461103',
  '461104',
  '461201',
  '461202',
  '461203',
  '461204',
  '461205',
  '461301',
  '461302',
  '461303',
  '461401',
  '461402',
  '461403',
  '461404',
  '461405',
  '461501',
  '461502',
  '461503',
  '461504',
  '461505',
  '461601',
  '461602',
  '461603',
  '461604',
  '461605',
  '461606',
  '461607',
  '461701',
  '461702',
  '461703',
  '461704',
  '461705',
  '461706',
  '461707',
  '461811',
  '461812',
  '461813',
  '461814',
  '461821',
  '461822',
  '461823',
  '461824',
  '461825',
  '461826',
  '461831',
  '461832',
  '461833',
  '461841',
  '461842',
  '461843',
  '461844',
  '461845',
  '461846',
  '461850',
  '461891',
  '461892',
  '461893',
  '461899',
  '461900',
  '462110',
  '462121',
  '462122',
  '462200',
  '462300',
  '462401',
  '462402',
  '463110',
  '463120',
  '463211',
  '463212',
  '463220',
  '463231',
  '463232',
  '463310',
  '463320',
  '463410',
  '463420',
  '463501',
  '463509',
  '463600',
  '463701',
  '463702',
  '463800',
  '463900',
  '464110',
  '464120',
  '464190',
  '464210',
  '464220',
  '464230',
  '464310',
  '464320',
  '464330',
  '464410',
  '464420',
  '464430',
  '464440',
  '464500',
  '464610',
  '464620',
  '464631',
  '464639',
  '464710',
  '464720',
  '464730',
  '464800',
  '464910',
  '464921',
  '464922',
  '464930',
  '464941',
  '464949',
  '464950',
  '464991',
  '464992',
  '464999',
  '465010',
  '465020',
  '465030',
  '466100',
  '466200',
  '466300',
  '466411',
  '466419',
  '466420',
  '466430',
  '466440',
  '466451',
  '466459',
  '466460',
  '466491',
  '466492',
  '466499',
  '467110',
  '467120',
  '467200',
  '467310',
  '467320',
  '468100',
  '468210',
  '468221',
  '468229',
  '468310',
  '468321',
  '468322',
  '468323',
  '468329',
  '468330',
  '468410',
  '468420',
  '468501',
  '468502',
  '468509',
  '468610',
  '468620',
  '468630',
  '468690',
  '468710',
  '468790',
  '468900',
  '469000',
  '471101',
  '471102',
  '471210',
  '471220',
  '471230',
  '471240',
  '471250',
  '471290',
  '472101',
  '472102',
  '472200',
  '472300',
  '472410',
  '472420',
  '472500',
  '472601',
  '472602',
  '472609',
  '472710',
  '472720',
  '472730',
  '472790',
  '473000',
  '474010',
  '474020',
  '474030',
  '475110',
  '475120',
  '475210',
  '475220',
  '475231',
  '475232',
  '475240',
  '475311',
  '475312',
  '475320',
  '475400',
  '475510',
  '475520',
  '475530',
  '475540',
  '475590',
  '476100',
  '476210',
  '476220',
  '476310',
  '476321',
  '476329',
  '476400',
  '476911',
  '476912',
  '476920',
  '476930',
  '476991',
  '476999',
  '477110',
  '477120',
  '477130',
  '477140',
  '477150',
  '477211',
  '477212',
  '477220',
  '477310',
  '477320',
  '477390',
  '477401',
  '477409',
  '477500',
  '477610',
  '477620',
  '477700',
  '477810',
  '477821',
  '477822',
  '477823',
  '477824',
  '477825',
  '477830',
  '477840',
  '477891',
  '477892',
  '477893',
  '477899',
  '477910',
  '477920',
  '477931',
  '477932',
  '477939',
  '478110',
  '478120',
  '478200',
  '478310',
  '478320',
  '479110',
  '479120',
  '479210',
  '479221',
  '479222',
  '479229',
  '479231',
  '479232',
  '479233',
  '479234',
  '479235',
  '479236',
  '479239',
  '491100',
  '491200',
  '492000',
  '493101',
  '493102',
  '493201',
  '493202',
  '493310',
  '493320',
  '493400',
  '493900',
  '494100',
  '494200',
  '495010',
  '495020',
  '501000',
  '502000',
  '503000',
  '504000',
  '511010',
  '511020',
  '512100',
  '512200',
  '521010',
  '521020',
  '522110',
  '522120',
  '522130',
  '522140',
  '522150',
  '522160',
  '522190',
  '522201',
  '522209',
  '522300',
  '522410',
  '522420',
  '522430',
  '522440',
  '522501',
  '522509',
  '522601',
  '522602',
  '523100',
  '523200',
  '531000',
  '532000',
  '533000',
  '551000',
  '552010',
  '552020',
  '552031',
  '552032',
  '552041',
  '552042',
  '552051',
  '552052',
  '553001',
  '553002',
  '553003',
  '553004',
  '554000',
  '559000',
  '561111',
  '561112',
  '561121',
  '561122',
  '561123',
  '561124',
  '561191',
  '561192',
  '561193',
  '561201',
  '561202',
  '561203',
  '562101',
  '562102',
  '562201',
  '562202',
  '563001',
  '563002',
  '563003',
  '563004',
  '564000',
  '581100',
  '581200',
  '581300',
  '581900',
  '582100',
  '582900',
  '591100',
  '591200',
  '591300',
  '591400',
  '592010',
  '592020',
  '601000',
  '602000',
  '603100',
  '603900',
  '611001',
  '611002',
  '611003',
  '612000',
  '619010',
  '619020',
  '619090',
  '621000',
  '622010',
  '622020',
  '629001',
  '629009',
  '631010',
  '631021',
  '631029',
  '639100',
  '639200',
  '641100',
  '641910',
  '641920',
  '641930',
  '642100',
  '642200',
  '643100',
  '643200',
  '649100',
  '649210',
  '649291',
  '649299',
  '649900',
  '651100',
  '651200',
  '652000',
  '653000',
  '661100',
  '661200',
  '661910',
  '661921',
  '661922',
  '661990',
  '662100',
  '662200',
  '662901',
  '662909',
  '663001',
  '663002',
  '663003',
  '681100',
  '681200',
  '682001',
  '682002',
  '682009',
  '683100',
  '683201',
  '683209',
  '691010',
  '691020',
  '691030',
  '692001',
  '692002',
  '692003',
  '692004',
  '692005',
  '692006',
  '692007',
  '701000',
  '702001',
  '702002',
  '702009',
  '711101',
  '711109',
  '711210',
  '711220',
  '711230',
  '711240',
  '711250',
  '712011',
  '712019',
  '712021',
  '712022',
  '712029',
  '721010',
  '721021',
  '721022',
  '721029',
  '722001',
  '722009',
  '731101',
  '731102',
  '731103',
  '731200',
  '732000',
  '733001',
  '733002',
  '733003',
  '733009',
  '741110',
  '741120',
  '741201',
  '741209',
  '741300',
  '741401',
  '741409',
  '742011',
  '742012',
  '742019',
  '742020',
  '743000',
  '749100',
  '749911',
  '749912',
  '749913',
  '749914',
  '749915',
  '749916',
  '749919',
  '749921',
  '749929',
  '749931',
  '749932',
  '749933',
  '749941',
  '749942',
  '749991',
  '749992',
  '749993',
  '749994',
  '749999',
  '750000',
  '771100',
  '771200',
  '772101',
  '772102',
  '772109',
  '772210',
  '772290',
  '773100',
  '773200',
  '773300',
  '773400',
  '773500',
  '773910',
  '773991',
  '773992',
  '773999',
  '774000',
  '775100',
  '775200',
  '781000',
  '782000',
  '791100',
  '791200',
  '799001',
  '799002',
  '799003',
  '799004',
  '800111',
  '800112',
  '800113',
  '800114',
  '800121',
  '800129',
  '800900',
  '811000',
  '812100',
  '812201',
  '812209',
  '812310',
  '812391',
  '812399',
  '813000',
  '821000',
  '822000',
  '823001',
  '823002',
  '823003',
  '823004',
  '823009',
  '824001',
  '824009',
  '829110',
  '829120',
  '829210',
  '829220',
  '829911',
  '829919',
  '829991',
  '829999',
  '841110',
  '841120',
  '841130',
  '841210',
  '841220',
  '841230',
  '841240',
  '841310',
  '841320',
  '841330',
  '841340',
  '841350',
  '841360',
  '841390',
  '842100',
  '842200',
  '842300',
  '842410',
  '842420',
  '842500',
  '843000',
  '851000',
  '852000',
  '853110',
  '853120',
  '853201',
  '853202',
  '853203',
  '853209',
  '853300',
  '854010',
  '854020',
  '855101',
  '855109',
  '855201',
  '855202',
  '855209',
  '855300',
  '855910',
  '855920',
  '855930',
  '855991',
  '855999',
  '856100',
  '856901',
  '856909',
  '861000',
  '862100',
  '862201',
  '862202',
  '862203',
  '862300',
  '869101',
  '869102',
  '869200',
  '869300',
  '869401',
  '869402',
  '869500',
  '869601',
  '869609',
  '869700',
  '869901',
  '869902',
  '869903',
  '869909',
  '871000',
  '872000',
  '873000',
  '879100',
  '879900',
  '881000',
  '889100',
  '889901',
  '889902',
  '889903',
  '889904',
  '889909',
  '901101',
  '901102',
  '901109',
  '901200',
  '901300',
  '902001',
  '902009',
  '903100',
  '903901',
  '903909',
  '911100',
  '911200',
  '912100',
  '912200',
  '913001',
  '913002',
  '913009',
  '914100',
  '914200',
  '920001',
  '920009',
  '931110',
  '931190',
  '931200',
  '931301',
  '931309',
  '931910',
  '931991',
  '931992',
  '931993',
  '931999',
  '932100',
  '932910',
  '932920',
  '932930',
  '932991',
  '932999',
  '941100',
  '941210',
  '941220',
  '942000',
  '949100',
  '949200',
  '949910',
  '949920',
  '949930',
  '949940',
  '949950',
  '949960',
  '949990',
  '951010',
  '951021',
  '951029',
  '952100',
  '952201',
  '952202',
  '952300',
  '952401',
  '952409',
  '952500',
  '952910',
  '952921',
  '952922',
  '952930',
  '952991',
  '952999',
  '953110',
  '953120',
  '953130',
  '953191',
  '953192',
  '953199',
  '953200',
  '954000',
  '961011',
  '961012',
  '961021',
  '961022',
  '962100',
  '962201',
  '962209',
  '962310',
  '962391',
  '962399',
  '963001',
  '963002',
  '963009',
  '964000',
  '969100',
  '969911',
  '969912',
  '969913',
  '969914',
  '969919',
  '969991',
  '969992',
  '969993',
  '969994',
  '969999',
  '970010',
  '970090',
  '981000',
  '982000',
  '990000',
]);

export function isSupportedAtecoCode(code: string | null | undefined): boolean {
  return !code || validAtecoCodesSet.has(code);
}
